module.exports = __webpack_public_path__ + "images/logo-dark-9f8505a4fbdc51c802b4a3783d125f19.png";